'use strict';

exports.__esModule = true;
var ROOM = exports.ROOM = {
  FILTER: 'ROOM_FILTER',
  FILTER_SUCCESS: 'ROOM_FILTER_SUCCESS',
  GET_ROOM_DETAILS: 'ROOM_GET_ROOM_DETAILS',
  GET_ROOM_DETAILS_SUCCESS: 'ROOM_GET_ROOM_DETAILS_SUCCESS',
  GET_ROOM_DETAILS_FAIL: 'ROOM_GET_ROOM_DETAILS_FAIL',
  SET_ROOM_SCHEDULE_TYPES: 'SET_ROOM_SCHEDULE_TYPES',
  SET_ROOM_RESERVATION_WINDOW: 'SET_ROOM_RESERVATION_WINDOW',
  SET_SELECTED_ROOM_SCHEDULE_TYPE: 'SET_SELECTED_ROOM_SCHEDULE_TYPE'
};

var filterWorkingHours = exports.filterWorkingHours = function filterWorkingHours(days, filterData) {
  return {
    type: ROOM.FILTER,
    days: days,
    filterData: filterData
  };
};

var getRoomDetails = exports.getRoomDetails = function getRoomDetails(clinics) {
  var loadAllDoctors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: ROOM.GET_ROOM_DETAILS,
    clinics: clinics,
    loadAllDoctors: loadAllDoctors
  };
};

var getRoomDetailsSuccess = exports.getRoomDetailsSuccess = function getRoomDetailsSuccess(roomScheduleTypes, roomReservationWindow) {
  return {
    type: ROOM.GET_ROOM_DETAILS_SUCCESS,
    roomScheduleTypes: roomScheduleTypes,
    roomReservationWindow: roomReservationWindow
  };
};

var getRoomDetailsFail = exports.getRoomDetailsFail = function getRoomDetailsFail(error) {
  return {
    type: ROOM.GET_ROOM_DETAILS_FAIL,
    error: error
  };
};

var setRoomScheduleTypes = exports.setRoomScheduleTypes = function setRoomScheduleTypes(roomScheduleTypes) {
  return {
    type: ROOM.SET_ROOM_SCHEDULE_TYPES,
    roomScheduleTypes: roomScheduleTypes
  };
};

var setRoomReservationWindow = exports.setRoomReservationWindow = function setRoomReservationWindow(roomReservationWindow) {
  return {
    type: ROOM.SET_ROOM_RESERVATION_WINDOW,
    roomReservationWindow: roomReservationWindow
  };
};

var setSelectedScheduleType = exports.setSelectedScheduleType = function setSelectedScheduleType(selectedScheduleType) {
  return {
    type: ROOM.SET_SELECTED_ROOM_SCHEDULE_TYPE,
    selectedScheduleType: selectedScheduleType
  };
};